<template>
  <div>
    <table-manager @filterChanged="filterChanged"
     @paginationChanged="paginationChanged"
     :options="options"/>
    <basic-table
      v-if="notificationsMessagesFields"
      :items="notificationsMessages"
      :fields="notificationsMessagesFields"
      :filter="filter"
      :perPage="perPage"

      v-model="totalRows"
      isEdit="true"/>

      <TableManagerBottom style="margin:5px" id="pagination" ref="pagination"
      :totalRows="totalRows"
      :perPage="perPage"
      @input="changePage"
      v-model="currentPage"/>
  </div>
</template>

<script>
import TableManagerBottom from '@/components/tables/TableManagerBottom'
export default {
  components: {
    TableManagerBottom
  },
  data () {
    return {
      options: {
        isShowAddButton: false,
        isDisablePerShow: false
      },
      filter: '',
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      selectedBank: null,
      notificationsMessagesFields: [
        { key: 'id', label: this.$i18n.t('ID'), sortable: true },
        { key: 'user_id', label: this.$i18n.t('User ID'), sortable: true },
        { key: 'subject', label: this.$i18n.t('Subject'), sortable: true },
        { key: 'message', label: this.$i18n.t('Message'), sortable: true },
        { key: 'creation_timestamp', label: this.$i18n.t('Creation time'), sortable: true, formatter: (val, key, item) => { return (new Date(val * 1000)).toLocaleString() } },
        { key: 'execution_timestamp', label: this.$i18n.t('Send time'), sortable: true, formatter: (val, key, item) => { return (new Date(val * 1000)).toLocaleString() } },
        { key: 'sending_method', label: this.$i18n.t('Sending method'), sortable: true },
        { key: 'error', label: this.$i18n.t('Error') }
      ]
    }
  },
  methods: {
    changePage (numPage) {
      this.currentPage = numPage
    },
    filterChanged (value) {
      this.$refs.pagination.setCurrentPage(1)
      this.currentPage = 1
      this.filter = ''
      this.filter = value
      this.$store.dispatch('Users/GET_NOTIFICATIONS_MESSAGES_PAGED', {
        page: 1,
        filter: this.filter,
        per_page: this.perPage
      }).then(el => {
        this.totalRows = this.$store.getters['Users/NOTIFICATIONS_MESSAGES_PAGED'].total_rows
      })
    },
    async paginationChanged (value) {
      this.filter = ''
      this.perPage = value
      if (this.$refs.pagination) this.$refs.pagination.setCurrentPage(1)
      if (this.currentPage === 1) {
        await this.$store.dispatch('Users/GET_NOTIFICATIONS_MESSAGES_PAGED', {
          page: this.currentPage,
          filter: this.filter,
          per_page: this.perPage
        }).then(el => {
          this.totalRows = this.$store.getters['Users/NOTIFICATIONS_MESSAGES_PAGED'].total_rows
        })
      }
      this.currentPage = 1
    }

  },
  watch: {
    currentPage: async function (val) {
      await this.$store.dispatch('Users/GET_NOTIFICATIONS_MESSAGES_PAGED', {
        page: val,
        filter: this.filter,
        per_page: this.perPage
      }).then(el => {
        this.totalRows = this.$store.getters['Users/NOTIFICATIONS_MESSAGES_PAGED'].total_rows
      })
      this.$refs.pagination.setCurrentPage(val)
    },
    notificationsMessages: function (val) {
      this.totalRows = this.$store.getters['Users/NOTIFICATIONS_MESSAGES_PAGED'].total_rows
    }
  },
  computed: {
    notificationsMessages () {
      return this.$store.getters['Users/NOTIFICATIONS_MESSAGES_PAGED'].notifcations
    }
  },
  async mounted () {
    await this.$store.dispatch('Users/GET_NOTIFTICATIONS_MESSAGES_PAGED', {
      page: 1,
      filter: '',
      per_page: this.perPage
    }).then(el => {
      this.totalRows = this.$store.getters['Users/NOTIFICATIONS_MESSAGES_PAGED'].total_rows
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/notificationsMessages/main.vue